var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-sheet',{staticClass:"px-4 pt-8 d-flex flex-wrap justify-center page-home-quick-access"},_vm._l((_vm.items),function(ref,i){
var title = ref.title;
var img = ref.img;
var link = ref.link;
return _c('quick-access-card',{key:i,attrs:{"title":title,"link":link,"img":img,"small":_vm.xs}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }